import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dAff$dCompat from "../Effect.Aff.Compat/index.js";
import {_getCurrentPositionAff} from "./foreign.js";
const getCurrentPosition = /* #__PURE__ */ (() => {
  const $0 = Effect$dAff._map(v => ({lat: v.latitude, lon: v.longitude}));
  return x => $0(Effect$dAff$dCompat.fromEffectFnAff(_getCurrentPositionAff(x)));
})();
const defaultOptions = {enableHighAccuracy: true, timeout: 5000, maximumAge: 30000};
export {defaultOptions, getCurrentPosition};
export * from "./foreign.js";
